import { render, staticRenderFns } from "./prescription-volume-total.vue?vue&type=template&id=59a79939&lang=pug&"
import script from "./prescription-volume-total.vue?vue&type=script&lang=ts&"
export * from "./prescription-volume-total.vue?vue&type=script&lang=ts&"
import style0 from "./prescription-volume-total.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports